export const API_URL = "https://check-if-legal.herokuapp.com"
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || ""
